import React from 'react'

// svg
import cup from '../Assets/cup.svg'
import cap from '../Assets/teacher.svg'
import tick from '../Assets/tick-circle.svg'
import book from '../Assets/book.svg'

const AboutHero:React.FC = () => {
  return (
    <section id='about' className='pt-40 md:pt-52 pb-10 flex items-center justify-center relative'>
      <img src={tick} alt='Tick' className='absolute top-44 -left-9 md:left-10 lg:left-[9rem]' />
      <img src={cup} alt='Cup' className='absolute top-20 right-[30px] md:top-[6rem] md:right-[190px] lg:right-[490px]' />
      <div className='container'>
        <div className='md:w-[77%] mx-auto'>
          <h2 className='text-darkText text-[32px] leading-[43.65px] text-center mb-10 md:px-[40px]'>Our Mission</h2>
          <p className='text-textColor text-[20px] leading-[30px] text-center md:px-[120px]'>The mission of exam compassNG is to change the narrative that students aspiring to
            take jamb exam have by providing them with the best online exam practices that
            involves taking series of quizzes that will help them prepare better for jamb and
            score nothing less than 300 in JAMB</p>
        </div>
      </div>
      <img src={cap} alt='cap' className='absolute bottom-28 -left-12 md:left-[120px] lg:left-[50px]' />
      <img src={book} alt='Book' className='absolute bottom-52 right-[10px] md:bottom-52 md:right-[70px] lg:bottom-52 lg:right-[112px]' />
    </section>
  )
}

export default AboutHero